import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const PolicyMasterReadSlice = createSlice({
  name: "PolicyMasterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PolicyMasterRead: (state) => {
      state.isLoading = true;
    },
    successPolicyMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePolicyMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPolicyMasterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  PolicyMasterRead,
  failurePolicyMasterRead,
  successPolicyMasterRead,
  clearPolicyMasterRead,
} = PolicyMasterReadSlice.actions;

export default PolicyMasterReadSlice.reducer;
